var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItcLauncherWhiteIco(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 26 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0h22a2 2 0 012 2v22a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm14.6 13.755a.41.41 0 010-.51l5.308-6.6A.4.4 0 0021.629 6H17.3a.36.36 0 00-.271.125l-3.72 4.233V6.392a.382.382 0 00-.37-.392h-4.09a.358.358 0 00-.246.1l-4.478 4.214a.4.4 0 00.246.686h3.968a.382.382 0 01.37.393v9.214a.381.381 0 00.37.393h3.86a.382.382 0 00.37-.393v-3.73l3.721 4.006a.359.359 0 00.263.117h4.336a.4.4 0 00.282-.647l-5.308-6.6z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
export default SvgItcLauncherWhiteIco;